import type {Breakpoint} from '../ViewportSizeListener';
import {useViewportSize} from '../ViewportSizeListener';

/** What counts as a phone, for `@media` blocks as well as this hook. */
export const MOBILE_QUERY = '(max-width: 700px)';

const breakpoints = [{key: 'mobile', query: MOBILE_QUERY}] as Array<
  Breakpoint<'mobile'>
>;
export const useIsMobile = () => {
  const view = useViewportSize(breakpoints);
  return view === 'mobile';
};
